(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_scholis-lang"] && !Shopify.designMode) return;
  try {
    (function () {
    function all() { return document.querySelectorAll('details[data-sl][open]'); }
    document.addEventListener('click', function (e) {
      all().forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      all().forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
    });
    document.addEventListener('toggle', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('details[data-sl]') || !t.open) return;
      all().forEach(function (d) { if (d !== t) d.removeAttribute('open'); });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
